import {
  HomeContentSection,
  HomeContentTypes,
  Milestone,
  Objective,
} from '@app/modules/Home/Data/types'
import type { Contact } from '@app/types'
import { atom } from 'jotai'

export const homeContentAtom = atom<HomeContentTypes | null>(null)

export const homeClientContactAtom = atom<Contact[] | null>((get) => {
  const section = get(homeContentAtom)?.find((s) => s.section === 'clientContact') as
    | HomeContentSection<Contact>
    | undefined

  const block = section?.blocks as unknown as Contact | undefined
  return block ? [block] : null
})

export const homeObjectivesAtom = atom<Objective | null>((get) => {
  const section = get(homeContentAtom)?.find((s) => s.section === 'objectives') as
    | HomeContentSection
    | undefined

  const block = section?.blocks as unknown as string[] | undefined
  return block ?? null
})

export const homeMilestonesAtom = atom<Milestone[] | null>((get) => {
  const section = get(homeContentAtom)?.find((s) => s.section === 'milestones') as
    | HomeContentSection
    | undefined

  const block = section?.blocks as unknown as Milestone[] | undefined
  return block ?? null
})

export type Contacts = {
  advisor?: Contact | null
  analyst?: Contact | null
  principal?: Contact | null
  contract?: Contact | null
  clientContact?: Contact | null
}

export const homeContactsAtom = atom<Contacts | null>((get) => {
  const advisorSection = get(homeContentAtom)?.find((s) => s.section === 'advisorContact') as
    | HomeContentSection<Contact>
    | undefined

  const analystContact = get(homeContentAtom)?.find((s) => s.section === 'analystContact') as
    | HomeContentSection<Contact>
    | undefined

  const principalContact = get(homeContentAtom)?.find((s) => s.section === 'principalContact') as
    | HomeContentSection<Contact>
    | undefined

  const contractContact = get(homeContentAtom)?.find((s) => s.section === 'contractContact') as
    | HomeContentSection<Contact>
    | undefined

  return {
    advisor: advisorSection?.blocks as unknown as Contact | null,
    analyst: analystContact?.blocks as unknown as Contact | null,
    principal: principalContact?.blocks as unknown as Contact | null,
    contract: contractContact?.blocks as unknown as Contact | null,
  }
})

homeContactsAtom.debugLabel = 'homeContactsAtom'
homeObjectivesAtom.debugLabel = 'homeObjectivesAtom'
homeMilestonesAtom.debugLabel = 'homeMilestonesAtom'
homeContentAtom.debugLabel = 'homeContentAtom'
homeClientContactAtom.debugLabel = 'homeClientContactAtom'
